import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'
import PreviewAttachments from 'modules/processes/components/ItemWizard/components/Preview/Attachments'
import PreviewDescription from 'modules/processes/components/ItemWizard/components/Preview/Description'
import PreviewTitle from 'modules/processes/components/ItemWizard/components/Preview/Title'
import { DataCollectionCategories } from 'modules/processes/domain'

import Address from './components/Address'
import EmergencyContact from './components/EmergencyContact'
import FiscalResidence from './components/FiscalResidence'
import General from './components/General'
import PersonalSituation from './components/PersonalSituation'

const COMPONENTS = {
  [DataCollectionCategories.generalInformation]: <General />,
  [DataCollectionCategories.address]: <Address />,
  [DataCollectionCategories.fiscal_residence]: <FiscalResidence />,
  [DataCollectionCategories.emergency_contact]: <EmergencyContact />,
  [DataCollectionCategories.personalSituation]: <PersonalSituation />,
}

const Preview = () => {
  const { previewValues } = usePreviewProvider()

  return (
    <Box>
      <PreviewTitle />
      <PreviewDescription />
      <PreviewAttachments />

      <Box paddingTop="s16" paddingBottom="s8">
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.title')}
        </Text.Normal>

        <Box paddingTop="s8">
          <Text.Normal>
            {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.description')}
          </Text.Normal>
        </Box>
      </Box>
      {(previewValues?.selectedCategories || []).map(
        (category: keyof typeof COMPONENTS) => COMPONENTS[category]
      )}
    </Box>
  )
}

export default Preview
